import React, {
  PureComponent,
} from 'react';
import {
  View,
  StyleSheet,
  PixelRatio,
  TouchableWithoutFeedback
} from 'react-native';
import {
  JDImage,
  JDDevice,
  JDText,
  JDTouchableWithoutFeedback,
} from '@jdreact/jdreact-core-lib';
import { pt } from '../../../components/utiles';
const dpr = parseInt(PixelRatio.get(), 10) || 1;

export default class SearchBanner extends PureComponent {
  static defaultProps = {
    keyword: '',
    cityName: '',
    placeholder: '',
    customStyle: {},
    showCityPickerClick: () => {} ,
    search: () => {},
    deletWordFocus: () => {},
}
  constructor (props) {
    super(props);
    this.state = {
      
    }
  }
search = () => {
  this.props.search();
}

clearKeyword = () => {
  this.props.deletWordFocus()
}

cityNameShow = (CityName) => {
  if(!CityName) return ''
  if(CityName.endsWith('市') || CityName.endsWith('县') || CityName.endsWith('州')){
      return CityName.slice(0, -1)
  }else {
      return CityName
  }
}


  render() {
    const { placeholder, showCityPickerClick, cityName, customStyle, keyword} = this.props 
    return (
      <View style={[styles.searchBar, customStyle]}>
          <View style={styles.searchArea_box}>
                <JDTouchableWithoutFeedback onPress={showCityPickerClick} style={styles.city_box}>
                  <View style={[styles.center, styles.city_cont]}>
                    <JDText style={[styles.searchAddrTxt, cityName.length > 2 ? styles.widthL : styles.widthS]} numberOfLines={1}>
                      {this.cityNameShow(cityName) || "北京"}
                    </JDText>
                    <JDImage
                      style={styles.searchAddrIcon}
                      resizeMode="contain"
                      source={{ uri: "https://m.360buyimg.com/img/jfs/t1/51517/36/21898/370/63170220Ebae237ba/37058a610ca0bc56.png" }}
                    />
                  </View>
                </JDTouchableWithoutFeedback>
          </View>
          <View style={[styles.searchInputBlock]}>
              <View style={styles.inputLine}></View>
              <JDTouchableWithoutFeedback onPress={this.search} contentContainerStyle={styles.searchInput}><View><JDText numberOfLines={1} style={keyword===''? styles.placeholderStyle : ''}>{keyword===''? placeholder : keyword}</JDText></View></JDTouchableWithoutFeedback>
              {(keyword !== '') && <JDTouchableWithoutFeedback onPress={this.clearKeyword} contentContainerStyle={styles.deleIconBox}>
                  <JDImage source={{
                      uri: 'https://img13.360buyimg.com/imagetools/jfs/t1/30458/33/18594/2967/63350a67E53466c5d/eaea0ac810a25bab.png'
                  }} style={styles.deleIcon} />
              </JDTouchableWithoutFeedback>}
          </View>
          <JDTouchableWithoutFeedback onPress={this.search} contentContainerStyle={styles.searchIconBox}>
            <JDImage source={{
                  uri: 'https://img11.360buyimg.com/imagetools/jfs/t1/93419/32/32547/3675/633508e2Eeb36fe28/75d56b961e42520a.png'
              }} style={styles.searchIcon} />
          </JDTouchableWithoutFeedback>
      </View>
    );
  }
}
const styles = StyleSheet.create({
  searchBar: {
    position: 'relative',
    height: JDDevice.getRpx(80),
    backgroundColor: '#ffffff',
    borderRadius: JDDevice.getRpx(40),
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row'
  },
  searchArea_box: {
		flexDirection: 'row',
		alignItems: 'center',
		height: pt(80),
		paddingLeft: pt(16)
	},
  center: {
		flexDirection: 'row',
		alignItems: 'center'
	},
	city_box: {
		paddingRight: pt(12),
		paddingLeft: pt(10),
	},
  widthL: { 
    width: pt(95),
   },
	widthS: { width: pt(80) },
  searchAddrTxt:{
		color:'#1a1a1a',
		textAlign: 'center'
		// maxWidth: pt(80)
	},
  searchAddrIcon:{
		width:pt(24),
		height:pt(24),
	},
searchInputBlock: {
    width: pt(470),
    height: pt(80),
    flexDirection: 'row',
    alignItems: 'center'
},
searchInput: {
  width: pt(388),
  height: pt(80),
  paddingVertical: 0,
  justifyContent: 'center'
},
inputLine: {
  width: pt(1),
  height: pt(40),
  marginRight: pt(24),
  backgroundColor:'#f6f6f6'
},
deleIconBox: {
  width: pt(70),
  height: pt(80),
  justifyContent: 'center',
  paddingHorizontal: pt(20),
},
deleIcon: {
  width: pt(28),
  height: pt(28),
  marginLeft: pt(10),
  marginRight: pt(10)
},
searchIconBox: {
  width: pt(80),
  height: pt(80),
  justifyContent: 'center',
  paddingRight:pt(40),
  paddingLeft: pt(10),
},
searchIcon: {
    width: pt(30),
    height: pt(30)
},
placeholderStyle: {
  color: 'rgba(0,0,0,0.25)'
}
  
})